import React, { useState, useEffect } from 'react';
import { Button, UncontrolledTooltip } from 'reactstrap';
import { FormattedMessage, useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import {FilterModal} from "../../layout/Modal/FilterModal";
import { UserMultiSelect } from '../UserMultiSelect';
import { getUsers as getUsersApi } from '../../../api/clients/users';
import { ACL } from '../../../config/constants';

const SelectUserFilter = ({ index, filters, applyFilters, filterKey, filterName, type }) => {
  const [showModal, setShowModal] = useState(false)
  const [selectedItems, setSelectedItems] = useState(filters ? [...filters] : [])
  const intl = useIntl();

  useEffect(() => {
      setSelectedItems(filters ? [...filters] : [])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showModal])

  const actionSubmit = () => {
    applyFilters(filterKey, [...selectedItems]);
    setShowModal(false)
  }

  const getUsersData = (searchString, callback) => {
    if (! ACL.CLIENT.USERS.LIST.hasAccess()) {
      return;
    }

    getUsersApi({
      pagination: {
        page: 1,
        q: searchString,
        per_page: 500,
      },
      hideNotification: false,
      hideLoading: true,
    }).then((response) => {
      if (!response || !response.data) {
        return;
      }

      callback(response.data.map((item) => {
        return { value: item.id, label: `${item.first_name} ${item.last_name} ${item.email}` }
      }));
    });
  }

  const renderButton = () => {
    if (type === 'button') {
      return (
        <Button
          color="primary"
          size="sm"
          className="btn-warning"
          type="button"
          id={`filter-icon-` + index}
          onClick={() => setShowModal(true)}
        >
          <FormattedMessage id="button.filter" />
        </Button>)
    }

    return (
      <Link
        to="#"
        className="cursor-pointer mr-2 link-icon-color"
        id={`filter-icon-${index}`}
        onClick={() => setShowModal(true)}
      >
        <FontAwesomeIcon
          size="lg"
          className="mr-2 cursor-pointer"
          pointerEvents="none"
          icon={faFilter}
          color={filters?.length > 0 ? '#524FD0' : '#8898aa'}
        />
      </Link>
    );
  }

  const renderTooltip = () => {
    return (
      <UncontrolledTooltip
        delay={ 0 }
        target={ `filter-icon-${index}` }
        modifiers={
          {
            preventOverflow: {
              enabled: true,
              boundariesElement: 'body'
            }
          }
        }
      >
        <FormattedMessage id="button.filter" />
      </UncontrolledTooltip>
    );
  }

  const renderSelect = () => {
    return (
      <>
      <UserMultiSelect
        defaultValue={filters ? filters.map((item) => { return { value: item.identifier, label: item.customTitle } }) : []}
        name="selected_users"
        className="mb-4"
        placeholder={ intl.formatMessage({ id: "components.pages.emailCampaigns.createEmailCampaign.createEmailCampaignForm.fields.selected_user_emails" }) }
        onChange={(selectedOptions) => {
          let newSelectedUsers = selectedOptions.map((option) => { return { identifier: option.value, label: intl.formatMessage({ id: filterName}), key: filterKey, customTitle: option.label } });
          setSelectedItems([...newSelectedUsers]);
        }}
        loadOptions={getUsersData}
      />
      </>
    );
  }

  return (
    <>
      {renderButton()}
      {renderTooltip()}
      <FilterModal
        showModal={showModal}
        closeModal={() => {
          setShowModal(false);
        }}
        confirmationYes={actionSubmit}
        modalTitle="components.shared.filters.selectUserFilter.modal_title"
      >
        {
          renderSelect()
        }
      </FilterModal>
    </>
  )
}

export { SelectUserFilter }
